import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export type SendStatus = 'idle' | 'sending' | 'success' | 'error';

export interface ContactPayload {
  name: string;
  email: string;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class ContactEmailService {
  private http = inject(HttpClient);

  readonly status = signal<SendStatus>('idle');
  readonly errorMessage = signal<string | null>(null);

  private getOS(): string {
    const ua = navigator.userAgent;
    if (/Windows/i.test(ua)) return 'Windows';
    if (/Mac OS X/i.test(ua) && !/iPhone|iPad|iPod/i.test(ua)) return 'macOS';
    if (/Android/i.test(ua)) return 'Android';
    if (/iPhone|iPad|iPod/i.test(ua)) return 'iOS';
    if (/Linux/i.test(ua)) return 'Linux';
    return 'Desconhecido';
  }

  private getDeviceType(): 'Mobile' | 'Desktop' {
    const ua = navigator.userAgent;
    return /Mobi|Android|iPhone|iPad|iPod/i.test(ua) ? 'Mobile' : 'Desktop';
  }

  async sendViaEmailJS(payload: ContactPayload): Promise<void> {
    this.status.set('sending');
    this.errorMessage.set(null);

    const body = {
      name: payload.name,
      email: payload.email,
      message: payload.message,
      from_initial: payload.name.charAt(0).toUpperCase(),
      time: new Date().toLocaleString('pt-BR', {
        dateStyle: 'short',
        timeStyle: 'short',
        timeZone: 'America/Sao_Paulo',
      }),
      os: this.getOS(),
      device: this.getDeviceType(),
      // location é resolvida no servidor a partir do IP real da requisição
    };

    try {
      await firstValueFrom(this.http.post('/api/send-email', body));
      this.status.set('success');
    } catch (error) {
      this.errorMessage.set('Não foi possível enviar. Tente novamente.');
      this.status.set('error');
    }
  }

  reset(): void {
    this.status.set('idle');
    this.errorMessage.set(null);
  }
}
